<script>
import navigation from "../components/global/navigation.vue";
import overviewDashboard from "../components/overview/overview-dashboard.vue";

export default {
  name: "OverviewPage",
  components: {
    navigation,
    overviewDashboard,
  },
  data() {
    let dismissed = false;
    try {
      dismissed = window.localStorage.getItem("experience-banner::overview::dismissed") === "1";
    } catch (e) {
      // localStorage unavailable
    }
    return {
      bannerDismissed: dismissed,
      steps: [
        {
          target: "#overview-tour-step-0",
          content: `Welcome Ashore! We’ve created the world’s fastest and easiest way to proof digital files. This tour will provide you with some brief points about the platform.`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#overview-tour-step-1",
          content: `If you want to jump right into Ashore, go here to upload files and create a review link to share with your approvers. That’s all you need to get started!`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#nav_proofs",
          content: `Any proofs you create will be listed here. We’ll track the status of all of your proofs for you, and give you a full timeline of changes.`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#nav_automation",
          content: `You can automate your approval process by adding workflows to your proofs. You can also customize email templates sent from Ashore (and create your own).`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#nav_contacts",
          content: `All of your contacts and their individual settings are listed and managed here.`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: "#nav_profile",
          content: `Upload your profile photo or add an email signature. If you have a paid account and a business email, you can also integrate your email with Ashore.`,
          params: {
            placement: "bottom",
            enableScrolling: false,
          },
        },
        {
          target: "#nav_account_settings",
          content: `Set your account defaults, and even create an approval checklist. If you have a paid account, you can rebrand Ashore with your company logo.`,
          params: {
            placement: "bottom",
            enableScrolling: false,
          },
        },
        {
          target: "#nav_billing",
          content: `Full-featured at a great price! Update your plan here to unlock more users, whitelabeling, and send more proofs per month.`,
          params: {
            placement: "bottom",
            enableScrolling: false,
          },
        },
        {
          target: "#hubspot-messages-iframe-container",
          content: `Want one-on-one training or have a question? Reach out to us using the support and we’ll be happy to assist. We’re available from 9 am to 5 pm CDT.`,
        },
      ],
      tourCallbacks: {
        onPreviousStep: this.tourPreviousStepCallback,
        onNextStep: this.tourNextStepCallback,
        onStop: this.SaveCompletionOfProductTours(),
      },
    };
  },
  mounted() {
    this.$A.ProductTourProcess("overview", this);
  },
  methods: {
    dismissBanner() {
      this.bannerDismissed = true;
      try {
        window.localStorage.setItem("experience-banner::overview::dismissed", "1");
      } catch (e) {
        // localStorage unavailable
      }
    },
    tourStateUpdate(currentStep) {
      var dropdown = document.getElementById("account_profile_dropdown");
      if (currentStep >= 4 && currentStep <= 6) {
        this.$A.AddClass("show", dropdown);
      } else {
        this.$A.RemoveClass("show", dropdown);
      }
    },
    tourPreviousStepCallback(currentStep) {
      this.tourStateUpdate(currentStep);
    },
    tourNextStepCallback(currentStep) {
      this.tourStateUpdate(currentStep);
    },
    SaveCompletionOfProductTours() {
      window.$A.SaveCompletionOfProductTours("overview");
    },
  },
};
</script>

<template>
  <div class="nav-margin overview-page">
    <navigation />

    <div class="experience-switch" v-if="!bannerDismissed">
      <div class="experience-msg">
        <span class="experience-pill">New</span>
        <span class="experience-text">You're using the new overview. What metrics would you like to see?</span>
      </div>
      <div class="experience-actions">
        <button type="button" class="experience-link experience-link-btn" v-b-modal="'feedbackModal-newOverview'">Give feedback</button>
      </div>
      <button
        type="button"
        class="experience-close"
        @click="dismissBanner"
        aria-label="Dismiss banner"
        title="Dismiss"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <feedbackModal
      name="feedbackModal-newOverview"
      campaign-key="new-overview-v1"
      title="How's the new overview?"
      subtitle="Your take helps us decide what to build next."
      scale-question="How useful are the metrics on this dashboard?"
      :scale-min="1"
      :scale-max="7"
      scale-low-label="Not useful"
      scale-high-label="Very useful"
      text-prompt="What metrics would you like to see?"
      text-placeholder="Tell us anything that helps."
      submit-label="Send feedback"
    />

    <overviewDashboard />

    <v-tour
      name="overviewTour"
      :steps="steps"
      :callbacks="tourCallbacks"
    ></v-tour>
  </div>
</template>

<style scoped>
.overview-page {
  min-height: 100vh;
  background: #f4f5f7;
}
.experience-switch {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 4px;
  padding: 8px 48px;
  background: rgba(1, 146, 86, 0.06);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  font-size: 13px;
  color: #4b5563;
}
.experience-msg,
.experience-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.experience-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: #019256;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  letter-spacing: 0.02em;
}
.experience-text {
  color: #4b5563;
}
.experience-link {
  color: #019256;
  font-weight: 600;
  text-decoration: none;
}
.experience-link:hover {
  text-decoration: underline;
  color: #017a48;
}
.experience-link-btn {
  background: transparent;
  border: 0;
  padding: 0;
  font: inherit;
  cursor: pointer;
}
.experience-divider {
  color: #c2c8d0;
  font-weight: 600;
}
.experience-close {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: #6b7280;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}
.experience-close:hover {
  background: rgba(15, 23, 42, 0.06);
  color: #111827;
}
</style>
